import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ApiUrl} from "../../../shared/models/apiurl.models";
import {HttpClient, HttpContext, HttpHeaders} from "@angular/common/http";
import {SKIP_AUTH} from "../../../theme/utils/auth-context";
import {LoadingMaskServiceService} from "../../loading-frame/loading-frame.component";
import {FormBuilder, Validators} from "@angular/forms";
import {Router} from "@angular/router";

import {LoginAction, LoginService} from "./login.service";
import {ValidationService} from "../../../shared/inputValidations/validation-service";
import {animate, keyframes, state, style, transition, trigger} from "@angular/animations";
import {delay} from "rxjs/operators";
import {ModalDismissReasons, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {UserStorageService} from "../../../services/UserStorageService";
import {TranslateService} from '@ngx-translate/core';
import {ToastService} from '../../../shared/toast/toast.service';


interface UserLogin {
  username: string;
  password: string;
}

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    animations: [
        trigger('popOverState', [
            state('show', style({
                opacity: 1
            })),
            state('hide', style({
                opacity: 1
            })),
            transition('show => hide', animate('500ms ease-in', keyframes([
                style({ transform: 'translate3d(-1px, 0, 0)', offset: 0.1 }),
                style({ transform: 'translate3d(2px, 0, 0)', offset: 0.2 }),
                style({ transform: 'translate3d(-4px, 0, 0)', offset: 0.3 }),
                style({ transform: 'translate3d(4px, 0, 0)', offset: 0.4 }),
                style({ transform: 'translate3d(-4px, 0, 0)', offset: 0.5 }),
                style({ transform: 'translate3d(4px, 0, 0)', offset: 0.6 }),
                style({ transform: 'translate3d(-4px, 0, 0)', offset: 0.7 }),
                style({ transform: 'translate3d(2px, 0, 0)', offset: 0.8 }),
                style({ transform: 'translate3d(-1px, 0, 0)', offset: 0.9 }),
            ]))),
        ])
    ]
    // trigger('shakeit', [
    //   state('shakestart', style({
    //     transform: 'scale(1)',
    //   })),
    //   state('shakeend', style({
    //     transform: 'scale(1)',
    //   })),
    //   transition('* => shakeend', animate('5000ms ease-in')),
    // ])
    ,
    standalone: false
})
export class LoginComponent implements OnInit, AfterViewInit, OnDestroy {
  // withCredentials: defense-in-depth alongside the AppInterceptor fix.
  // This options object is used for login/register/OTP - the login response
  // is what first tries to set the sale4all_refresh cookie, and without
  // credentials the browser silently drops that Set-Cookie. See
  // theme/utils/app-interceptor.ts for the full incident writeup.
  private options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': this.apiKey.getJWTToken()
    }),
    withCredentials: true
  }
  /**
   * Phone login / signup calls (2026-10-24): no Authorization header and
   * SKIP_AUTH, so a leftover session can never be attached to them.
   */
  private authOptions() {
    return {
      headers: new HttpHeaders({'Content-Type': 'application/json'}),
      withCredentials: true,
      context: new HttpContext().set(SKIP_AUTH, true),
    };
  }
  private static readonly DEFAULT_COOLDOWN = 90;
  acceptMarketing = false;   // marketing opt-in for NEW accounts, off by default
  otpError: string | null = null;
  otpInfo: string | null = null;   // e.g. "a code sent earlier is still valid"
  sending = false;
  resendLeft = 0;
  private resendTimer: any = null;
  @ViewChild('loginModel') loginModel!: TemplateRef<unknown>;

  passwordRegex= '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]+$';
  loginForm: any;
  registerForm: any;
  loginError: boolean = false;
  showAnimation: boolean = false;
  states:any = {};
  otpSent = false;
  isDimmed!: boolean;
  phoneFocus = false;
  constructor(
    private http: HttpClient,
    private apiKey: ApiUrl,
    private loadingMaskServiceService: LoadingMaskServiceService,
    private formBuilder: FormBuilder,
    private route: Router,
    private modalService: NgbModal,
    public el: ElementRef,
    private userStorageService: UserStorageService,
    private loginService:LoginService,
    private toastService: ToastService,
    private translate: TranslateService
  ) {
    this.states['state1'] = 'shakestart';
    this.states['state2'] = 'shakeend';

    this.loginForm = this.formBuilder.group({
      username: '',
      password: '',
      countryCode: ['+972', Validators.required],
      phoneNumber: [
        '',
        [
          Validators.required,
          Validators.pattern(/^\d{3}-\d{3}-\d{4}$/), // matches 050-727-3222
        ],
      ],
      otp: ['']
    });
    this.registerForm = this.formBuilder.group({
      username: ['', [Validators.required, ValidationService.emailValidator]],
      password: ['',[Validators.required, ValidationService.passwordValidator]],
      first_name:['',[Validators.required]],
      email:[''],
      acceptAdv:[''],
      phoneNumber:[''],
      acceptTerms:[''],
      page_source:[''],
      codeValidation:[null],
      last_name:['',[Validators.required]],
      confirmPassword:['',[Validators.required, ValidationService.passwordValidator]]
    })

    this.loginService.getClickEvent().subscribe(res=>{
      if(res === LoginAction.Open){
        this.openLoginModal()
      }else {
        this.closeLoginModal()
      }

    })
  }
  show = true;
  get statusName(){
    return this.show?'show':'hide';
  }

  get phoneNumberDisplay(): string {
    return this.loginForm.get('phoneNumber')?.value || 'למספר שהזנתם';
  }
  shakeMe(){
    this.show = false;
    setTimeout(()=>this.show = true, 500)
  }

  ngAfterViewInit() {
    this.apiKey.getUrlParam('loginOpenForm').subscribe((res:boolean)=>{
      if(res)
        this.loginService.sendClickEvent();
    })


  }

  ngOnInit(): void {

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  closeLoginModal(){
    this.modalService.dismissAll()
  }
  openLoginModal(){
    this.modalService.open(this.loginModel, {
      ariaLabelledBy: 'login-modal-title',
      backdropClass: 'login-backdrop',
      centered: true,
      keyboard: true,
      scrollable: true,
      windowClass: 'login-modal-window'
    }).result.then((result) => {
    }, (reason) => {
      this.route.navigate([] )
       console.log(`Dismissed ${this.getDismissReason(reason)}`);
    });
  }
  onRegisterSubmit() {
    if (this.registerForm.dirty && this.registerForm.valid) {
      this.http.post<any>(this.apiKey.registerUser(), JSON.stringify(this.registerForm.value), this.options).subscribe(data => {
        console.log(data)
      })
    }else{
      console.log(this.registerForm.valid)
    }

  }
  onLoginSubmit() {

    this.http.post<any>(this.apiKey.loginUser(), JSON.stringify(this.loginForm.value), this.options).subscribe(data => {
      if(data['non_field_errors'] != null){
        this.shakeMe();
        this.loginError = true;
      }else{
        this.userStorageService.saveUser(data)
        this.completeLogin()
      }

    },error => {
      this.shakeMe();
      this.loginError = true;
    })
  }


  onclick() {
    this.showAnimation = true;
  }


  countries = [
    { name: '', dial_code: '+972', flag: '🇮🇱' },
  ];



  /** Hebrew text per server statusCode (the server `message` wins when present). */
  private static readonly OTP_MESSAGES: Record<string, string> = {
    INVALID_CODE: 'הקוד שגוי.',
    CODE_LOCKED: 'ניצלתם את כל הניסיונות לקוד זה. שלחו קוד חדש.',
    CODE_EXPIRED: 'תוקף הקוד פג. שלחו קוד חדש.',
    OTP_COOLDOWN: 'ניתן לשלוח קוד חדש בעוד רגע.',
    OTP_SEND_LIMIT: 'הגעתם למגבלת שליחת הקודים. נסו שוב מאוחר יותר.',
    INVALID_PHONE: 'מספר הטלפון אינו תקין.',
    PHONE_LINKED_OTHER_ACCOUNT: 'מספר הטלפון הזה מקושר לחשבון אחר.',
    SMS_SEND_FAILED: 'לא הצלחנו לשלוח את הקוד. נסו שוב בעוד כמה דקות.',
    TERMS_NOT_ACCEPTED: 'יש לאשר את תנאי השימוש.',
    PHONE_ASSOCIATED: 'למספר הזה כבר יש חשבון. נסו להתחבר שוב.',
    INVALID_REGISTRATION: 'לא הצלחנו ליצור חשבון למספר הזה.',
  };

  /**
   * One button for login AND signup (2026-10-24): LOGIN first; a number with
   * no account (PHONE_NOT_ASSOCIATED) is sent again as PHONE_SIGNUP_AUTO. The
   * account is created only after the code is verified.
   */
  sendOtp() {
    if (this.loginForm.get('phoneNumber')?.invalid || this.sending) return;
    if (this.otpSent && this.resendLeft > 0) return;
    const { countryCode, phoneNumber } = this.loginForm.value;
    const phone = `${countryCode}${phoneNumber.replace(/^0/, '')}`;

    this.registerForm.patchValue({
      username: `${phone}@sale4all.co.il`,
      email: `${phone}@sale4all.co.il`,
      phoneNumber: phone,
      page_source: 'LOGIN',
      // Logging in is not a consent decision - the server ignores these on LOGIN.
      acceptAdv: false,
      acceptTerms: true,
      codeValidation: null,
    });
    this.otpError = null;
    this.sending = true;
    this.postPhone(this.registerForm.value).subscribe({
      next: (data) => {
        const code = data?.statusCode;
        if (code === 'PHONE_NOT_ASSOCIATED' || code === 'PHONE_NOT_ASSOCIATED_TO_ACCOUNT') {
          this.registerForm.patchValue({
            page_source: 'PHONE_SIGNUP_AUTO',
            acceptTerms: true,               // "בהמשך הפעולה אתם מאשרים..." line
            acceptAdv: this.acceptMarketing, // opt-in checkbox, off by default
          });
          this.postPhone(this.registerForm.value).subscribe({
            next: (res) => this.onCodeSent(res),
            error: (err) => this.onSendError(err),
          });
          return;
        }
        this.onCodeSent(data);
      },
      // SCRUM-142: a non-2xx (429 / 400 / 409 / 503) must become a real
      // message, not the GlobalErrorHandler's generic crash toast.
      error: (err) => this.onSendError(err),
    });
  }

  /** phone/validation without any session (SKIP_AUTH). */
  private postPhone(body: any) {
    return this.http.post<any>(this.apiKey.getPhoneValidationUrl(), JSON.stringify(body), this.authOptions());
  }

  private onCodeSent(data: any) {
    this.sending = false;
    if (data?.statusCode == 200) {
      this.otpSent = true;
      this.otpError = null;
      this.otpInfo = null;
      this.startCooldown(Number(data?.cooldown) || LoginComponent.DEFAULT_COOLDOWN);
      return;
    }
    this.showOtpError(data);
  }

  private onSendError(err: any) {
    this.sending = false;
    const body = err?.error;
    // A refused resend (429 OTP_COOLDOWN / OTP_SEND_LIMIT) while a code of
    // this flow is still valid (codeActive): go to code entry - the user can
    // type the code they already received.
    if (err?.status === 429 && body?.codeActive) {
      this.otpSent = true;
      this.otpError = null;
      this.otpInfo = 'קוד שנשלח קודם עדיין בתוקף - הזינו אותו';
      this.startCooldown(Number(body?.retryAfter) || LoginComponent.DEFAULT_COOLDOWN);
      return;
    }
    this.showOtpError(body, err?.status);
  }

  /** Inline + toast message for a phone/validation failure. */
  private showOtpError(body: any, httpStatus?: number) {
    const code = body?.statusCode || body?.error;
    const serverMessage = typeof body?.message === 'string'
      && body.message !== 'ACCEPTED_AUTHORITATIVE_INFORMATION' ? body.message : null;
    let msg = serverMessage || LoginComponent.OTP_MESSAGES[code] || null;
    if (!msg) {
      msg = httpStatus === 429 ? 'יותר מדי ניסיונות. המתינו מעט ונסו שוב.' : 'הפעולה נכשלה. נסו שוב.';
    }
    if (code === 'INVALID_CODE' && !serverMessage && typeof body?.attemptsLeft === 'number') {
      msg += ` נותרו ${body.attemptsLeft} ניסיונות.`;
    }
    if ((code === 'OTP_COOLDOWN' || code === 'OTP_SEND_LIMIT') && body?.retryAfter) {
      this.startCooldown(Number(body.retryAfter));
    }
    this.otpError = msg;
    this.otpInfo = null;
    this.toastService.error(msg, {duration: 5000});
  }

  /** "שליחת קוד חדש בעוד ..." - driven by the server's cooldown / retryAfter. */
  get resendLabel(): string {
    const s = this.resendLeft;
    return s >= 60 ? `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}` : `${s}`;
  }

  private startCooldown(seconds: number) {
    this.stopCooldown();
    this.resendLeft = Math.max(0, Math.ceil(seconds || 0));
    if (typeof window === 'undefined' || this.resendLeft <= 0) return;
    this.resendTimer = setInterval(() => {
      this.resendLeft = Math.max(0, this.resendLeft - 1);
      if (!this.resendLeft) this.stopCooldown();
    }, 1000);
  }

  private stopCooldown() {
    if (this.resendTimer) {
      clearInterval(this.resendTimer);
      this.resendTimer = null;
    }
  }

  ngOnDestroy(): void {
    this.stopCooldown();
  }

  changePhone() {
    this.otpSent = false;
    this.otpError = null;
    this.otpInfo = null;
    this.stopCooldown();
    this.resendLeft = 0;
  }

  otpAdvance(event: Event, next: HTMLInputElement | null) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/\D/g, '').slice(0, 1);
    if (input.value && next) next.focus();
  }

  otpBack(event: KeyboardEvent, previous: HTMLInputElement | null) {
    const input = event.target as HTMLInputElement;
    if (event.key === 'Backspace' && !input.value && previous) previous.focus();
  }

  otpPaste(event: ClipboardEvent, boxes: HTMLInputElement[]) {
    const digits = event.clipboardData?.getData('text').replace(/\D/g, '').slice(0, boxes.length) ?? '';
    if (!digits) return;
    event.preventDefault();
    boxes.forEach((box, index) => box.value = digits[index] ?? '');
    boxes[Math.min(digits.length, boxes.length) - 1]?.focus();
    this.otpCollect(boxes);
  }

  otpCollect(boxes: HTMLInputElement[]) {
    this.loginForm.patchValue({otp: boxes.map(box => box.value).join('')});
  }

  onSubmit() {
    if (!this.otpSent || this.sending) return;
    const otp = this.loginForm.value.otp;
    this.registerForm.patchValue({codeValidation: `${otp}`});
    this.otpError = null;
    this.otpInfo = null;
    this.sending = true;
    // SCRUM-142: both calls have error handlers (no generic crash toast).
    this.postPhone(this.registerForm.value).subscribe({
      next: (data) => {
        if (data?.statusCode == 200 && data?.message == 'ACCEPTED_AUTHORITATIVE_INFORMATION') {
          this.http.post<any>(this.apiKey.loginUser(), JSON.stringify(this.registerForm.value), this.authOptions()).subscribe({
            next: (res) => {
              this.sending = false;
              if (res?.status == 200) {
                this.userStorageService.saveUser(res['user']);
                this.completeLogin();
              } else {
                this.showOtpError({message: 'ההתחברות נכשלה. בקשו קוד חדש ונסו שוב.'});
              }
            },
            error: (err) => {
              this.sending = false;
              this.showOtpError({message: err?.status === 429
                ? 'יותר מדי ניסיונות. המתינו מעט ונסו שוב.'
                : 'ההתחברות נכשלה. בקשו קוד חדש ונסו שוב.'});
            }
          });
          return;
        }
        // INVALID_CODE / CODE_LOCKED / CODE_EXPIRED come back as HTTP 203.
        this.sending = false;
        this.showOtpError(data);
      },
      error: (err) => {
        this.sending = false;
        this.showOtpError(err?.error, err?.status);
      }
    });
  }

  onGoogleLogin() {
    console.log('Google login clicked');
    // TODO: Connect Google Auth
  }

  completeLogin() {
    this.otpSent = false;
    this.otpError = null;
    this.otpInfo = null;
    this.stopCooldown();
    this.closeLoginModal();
    this.toastService.success(
      this.translate.instant('sale4you.auth.login.success'),
      {
        message: this.translate.instant('sale4you.auth.login.welcome'),
        duration: 3500,
      }
    );
  }
}
